module.exports = __webpack_public_path__ + "static/img/map_en.b19a4be9.png";